import AppNativeBridge from "./common-bridge";
class CommonEvents {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
    static emitEventToNativeApp(event, data) {
        AppNativeBridge.emitEventToNativeApp(event, data);
    }
    static listenEventFromNativeApp(event, callback) {
        AppNativeBridge.listenEventFromNativeApp(event, callback);
    }
    static listenOnceEventFromNativeApp(event, callback) {
        AppNativeBridge.listenOnceEventFromNativeApp(event, callback);
    }
    static invokeEventToNativeApp(channel, data) {
        return AppNativeBridge.invokeEventToNativeApp(channel, data);
    }
}
CommonEvents.EVENTS = {
    ON_APP_FOREGROUND: 'onAppForeground',
    ON_VITE_PRELOAD_ERROR: 'onSwymVitePreloadError',
    ON_ENTER_FULLSCREEN: 'onEnterFullScreen',
    ON_LEAVE_FULLSCREEN: 'onLeaveFullScreen',
    NOTIFY_APP_SWYM_LOGOUT: 'SwymEvents:notifySWYMLogout',
    NOTIFY_APP_DOWNLOAD_URL: 'SwymEvents:notifyDownloadURL',
    NOTIFY_APP_UPDATE_INSTALL: 'SwymEvents:notifyAppUpdateInstall',
    NOTIFY_APP_PWA_UPDATE_WAITING: 'SwymEvents:notifyAppUpdatePWAWaiting',
    NOTIFY_REALTIME_MESSAGE: 'SwymEvents:notifyRealtimeMessage',
    NOTIFY_APP_SWYM_INIT_END: 'onInitializationEnd',
    NOTIFY_APP_UWP_PROPERTIES: 'SwymEvents:notifyUWPAppProperties',
    NOTIFY_APP_TOPFRAME_INIT: 'SwymEvents:notifyTopFrameInit',
    ON_APP_MULTIWINDOWS: 'onAppMultiWindows',
    NOTIFY_MULTIWINDOW_ADD: 'multi-window:add',
    NOTIFY_MULTIWINDOW_DELETE: 'multi-window:delete',
    NOTIFY_MULTIWINDOW_FOCUS: 'multi-window:focus',
};
export default CommonEvents;
//# sourceMappingURL=common-events.js.map